import { Injectable } from '@angular/core'
import { Router, CanActivate } from '@angular/router'

import { UsersService } from '../services/users.service'

@Injectable()
export class AdminGuard implements CanActivate {

  constructor (
    private usersService: UsersService,
    private router: Router) { }

  canActivate (): boolean {
    if (this.usersService.currentUser.isAdmin()) return true

    this.router.navigate(['/'])
    return false
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/guards/admin.guard.ts